import type { ReactNode } from 'react';

export interface EmptyStateProps {
  /** Emoji or glyph shown above the title. */
  icon?: ReactNode;
  title: string;
  /** One line explaining what to do next. */
  hint?: ReactNode;
  /** Optional call-to-action (usually a <Button/>). */
  action?: ReactNode;
}

/** Centered placeholder used for empty lists and page stubs. */
export function EmptyState({ icon = '·', title, hint, action }: EmptyStateProps) {
  return (
    <div className="empty">
      <div className="empty__icon" aria-hidden="true">
        {icon}
      </div>
      <div className="empty__title">{title}</div>
      {hint ? <div>{hint}</div> : null}
      {action ? <div style={{ marginTop: 8 }}>{action}</div> : null}
    </div>
  );
}
